import {
  API_STATUS,
  ERROR_MESSAGES,
  HTTP_STATUS,
} from '@/constants/errorConstants';

export function handleApiError(error) {
  if (!error.response) {
    if (error.request) {
      return ERROR_MESSAGES.NETWORK.NO_RESPONSE;
    }
    return ERROR_MESSAGES.NETWORK.GENERAL;
  }

  const { status, data } = error.response;

  return (
    ERROR_MESSAGES.HTTP[status] ||
    data?.message ||
    ERROR_MESSAGES.NETWORK.GENERAL
  );
}

export function handleApiSuccess(data) {
  if (!data) {
    return {
      success: false,
      message: ERROR_MESSAGES.NETWORK.NO_SERVER_RESPONSE,
    };
  }

  if (data.status === API_STATUS.SUCCESS) {
    return {
      success: true,
      message: data.message || ERROR_MESSAGES.API.SUCCESS,
      data: data.data,
    };
  }

  return {
    success: false,
    message: data.message || ERROR_MESSAGES.API.FAILURE,
  };
}

export function handleValidationError(error) {
  if (!error.response?.data?.errors) {
    return handleApiError(error);
  }

  const errors = error.response.data.errors;
  const messages = Object.values(errors).flat();
  return messages.join('. ');
}

export function handleFileUploadError(error) {
  if (!error.response) {
    return ERROR_MESSAGES.FILE.UPLOAD_FAILED;
  }

  const { status, data } = error.response;

  switch (status) {
    case HTTP_STATUS.INSUFFICIENT_STORAGE:
      return ERROR_MESSAGES.FILE.TOO_LARGE;
    case HTTP_STATUS.UNPROCESSABLE_ENTITY:
      return ERROR_MESSAGES.FILE.UNSUPPORTED_FORMAT;
    default:
      return data?.message || ERROR_MESSAGES.FILE.UPLOAD_FAILED;
  }
}

export function handleAuthError(error) {
  if (!error.response) {
    return ERROR_MESSAGES.AUTH.CONNECTION_FAILED;
  }

  const { status, data } = error.response;

  switch (status) {
    case HTTP_STATUS.UNAUTHORIZED:
      return ERROR_MESSAGES.AUTH.SESSION_EXPIRED;
    case HTTP_STATUS.FORBIDDEN:
      return ERROR_MESSAGES.AUTH.UNAUTHORIZED;
    default:
      return data?.message || ERROR_MESSAGES.AUTH.CONNECTION_FAILED;
  }
}
